import { Button, Label, Node, Toggle, _decorator } from 'cc';
import BaseTool from '../BaseTool';
import BaseColorAdjusterView from './AdjusterView/BaseColorAdjusterView';
import ColorBalanceAdjusterView from './AdjusterView/ColorBalanceAdjusterView';
import ColorLevelAdjusterView from './AdjusterView/ColorLevelAdjusterView';
import HSLAdjusterView from './AdjusterView/HSLAdjusterView';
import ItemGenerator from '../../Components/Misc/ItemGenerator';
import { exportJsonFile } from '../../Utils/Utility';

const { ccclass, property } = _decorator;
const COLOR_ADJUST_INFO_FILE_NAME = 'color-adjust-info';

@ccclass('ColorAdjusterManager')
export default class ColorAdjusterManager extends BaseTool {
    @property(ItemGenerator)
    private readonly adjusterOptionGenerator: ItemGenerator = null;

    @property(ColorLevelAdjusterView)
    private readonly colorLevelAdjusterView: ColorLevelAdjusterView = null;

    @property(ColorBalanceAdjusterView)
    private readonly colorBalanceAdjusterView: ColorBalanceAdjusterView = null;

    @property(HSLAdjusterView)
    private readonly hslAdjusterView: HSLAdjusterView = null;

    @property(Toggle)
    private readonly enableToggle: Toggle = null;

    @property(Button)
    private readonly exportButton: Button = null;

    private _colorAdjusterViews: BaseColorAdjusterView[] = [];
    private _colorAdjusterToggles: Toggle[] = [];

    protected onLoad() {
        this._colorAdjusterViews = [this.colorLevelAdjusterView, this.colorBalanceAdjusterView, this.hslAdjusterView];
        this.adjusterOptionGenerator.displayItemCount = this._colorAdjusterViews.length;
        this.adjusterOptionGenerator.items.forEach((item, index) => {
            const toggle = item.getComponentInChildren(Toggle);
            const adjuster = this._colorAdjusterViews[index];
            item.getComponentInChildren(Label).string = adjuster.displayName || adjuster.node.name;
            this._colorAdjusterToggles.push(toggle);
            toggle.node.on(Toggle.EventType.TOGGLE, () => {
                adjuster.node.active = toggle.isChecked;
            });
            adjuster.on(Node.EventType.ACTIVE_CHANGED, () => {
                toggle.isChecked = adjuster.node.active;
            });
            toggle.isChecked = adjuster.node.active;
            // place latest touched view on top of other views
            adjuster.on(
                Node.EventType.TOUCH_START,
                () => {
                    adjuster.node.setSiblingIndex(adjuster.node.parent.children.length);
                },
                this,
                true,
            );
        });
        this.enableToggle.on(Toggle.EventType.TOGGLE, () => {
            this._colorAdjusterViews.forEach((view) => {
                view.isEnabled = this.enableToggle.isChecked;
            });
        });
        this.exportButton.on(Button.EventType.CLICK, this._export, this);
    }

    private _export() {
        const info = {};
        this._colorAdjusterViews
            .filter((view) => view.isEnabled)
            .forEach((view) => {
                const adjustInfo = view.collectAdjustInfo();
                if (adjustInfo) {
                    const { name } = adjustInfo;
                    delete adjustInfo.name; // Remove name from the info object
                    // Store the info in the main info object using the name as the key
                    info[name] = adjustInfo;
                }
            });
        exportJsonFile(JSON.stringify(info, null, 2), COLOR_ADJUST_INFO_FILE_NAME);
    }
}
